import React, { useState } from 'react';
import { ErrorResponse } from '@eika-infrastruktur/request';
import { LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import '@eika/card-style/src/ErrorCard.scss';

type RequestExceptionWithResponse = import('@eika-infrastruktur/request').RequestExceptionWithResponse;

function getRcid(exception: RequestExceptionWithResponse | ErrorResponse) {
    if ('requestCorrelationId' in exception) {
        return exception.requestCorrelationId?.value;
    }
    if ('rcid' in exception) {
        return exception.rcid;
    }
    return null;
}

type ExceptionInformationProps = {
    exception: RequestExceptionWithResponse | ErrorResponse;
    showLessText: string;
    showMoreText: string;
};
export const ErrorCardExceptionInformation = ({ exception, showLessText, showMoreText }: ExceptionInformationProps) => {
    const [showErrorInfo, setShowErrorInfo] = useState(false);

    const errorName = 'errorName' in exception ? exception.errorName : exception.name;
    const exceptionStatus = 'status' in exception ? exception.status : undefined;
    const exceptionRCID = getRcid(exception);

    return (
        <>
            <LinkButton
                icon={IconTypes.LITEN_PIL_NED}
                iconOnRightSide
                onClick={() => setShowErrorInfo((showErrorInfo) => !showErrorInfo)}
            >
                {showErrorInfo ? showLessText : showMoreText}
            </LinkButton>

            {showErrorInfo && (
                <>
                    <dl>
                        <dt>Code</dt>
                        <dd>{exception.code}</dd>
                        {errorName && (
                            <>
                                <dt>Name</dt>
                                <dd>{errorName}</dd>
                            </>
                        )}
                        {exceptionStatus && (
                            <>
                                <dt>Status</dt>
                                <dd>{exceptionStatus}</dd>
                            </>
                        )}
                        <dt>Type</dt>
                        <dd>{exception.type}</dd>
                        {exceptionRCID && (
                            <>
                                <dt>RCID</dt>
                                <dd>{exceptionRCID}</dd>
                            </>
                        )}
                    </dl>
                    <pre>{exception.message}</pre>
                </>
            )}
        </>
    );
};
